import { useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { MENUITEMS_DEALER } from "../../../constant/menu";
import { LogOut, ChevronDown, ChevronUp, ChevronRight, Home, Users, Shield, ShoppingBag, Codepen, Printer, User,Volume1, Trello } from "react-feather";
import { useToggle } from "../../../context/contextProvider";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const SidebarMenu = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const { close } = useToggle();
    const [toggle, setToggle] = useState(false)
    const handleToggle = () => setToggle(!toggle);
    //   const navigate = useNavigate();
    const history = useHistory();

    console.log("Open", openIndex)

    const isMobile = window.innerWidth <= 768;

    const handleSubToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handleLinkClick = (path) => {
        // navigate(path);
        history.push(path)
        if (isMobile) close();
    };

    const handleLogout = () => {
        localStorage.clear();
        history.push("/login")
        if (isMobile) close();
    };

    return (
        <ul className="sidebar-menu">
            {MENUITEMS_DEALER.map((item, index) => (
                <li key={index} className="menu-item">
                    {/* SUB MENU */}
                    {item.type === "sub" && (
                        <>
                            <div
                                className="menu-title"
                                onClick={() => handleSubToggle(index)}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                    {
                                        index == 0 ?
                                            <Users style={{ width: "15px", height: "18px" }} />
                                            : index == 1 ?
                                                <Shield style={{ width: "15px", height: "18px" }} />
                                                : index == 2 ?
                                                    <Trello style={{ width: "15px", height: "18px" }} />
                                                    : index == 3 ?
                                                        <ShoppingBag style={{ width: "15px", height: "18px" }} />
                                                        : index == 4 ?
                                                            <Codepen style={{ width: "15px", height: "18px" }} />
                                                            : index == 5 ?
                                                                <Printer style={{ width: "15px", height: "18px" }} />
                                                                : index == 6 ?
                                                                    <User style={{ width: "15px", height: "18px" }} />
                                                                    : index == 7 ?
                                                                        <Volume1 style={{ width: "15px", height: "18px" }} />
                                                                        : index == 8 ?
                                                                            <Volume1 style={{ width: "15px", height: "18px" }} /> :
                                                                            <LogOut style={{ width: "15px", height: "18px" }} />
                                    }
                                    <span>{item.title}</span>
                                </div>

                                <ChevronRight
                                    className={`arrow ${openIndex === index ? "rotate" : ""}`}
                                />
                            </div>

                            {openIndex === index && (
                                <ul className="submenu">
                                    {item.children.map((child, i) => (
                                        <li key={i}>
                                            <NavLink
                                                to={child.path}
                                                onClick={() => handleLinkClick(child.path)}
                                                className={({ isActive }) =>
                                                    isActive ? "active" : ""
                                                }
                                            >
                                                {child.title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </>
                    )}

                    {/* LOGOUT */}
                    {item.type === "onClick" && (
                        <div onClick={() => handleToggle()} >
                            <LogOut size={16} />
                            <span
                                style={{
                                    fontFamily: "Nunito",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                    paddingLeft: "5px"
                                }}>{item.title}</span>

                            <Modal isOpen={toggle} toggle={() => handleToggle()}>
                                <ModalHeader >
                                    Log out
                                </ModalHeader>
                                <ModalBody>
                                    Are you sure you want to logout from Admin Dashboard?
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="default" onClick={() => handleToggle()}>
                                        Cancel
                                    </Button>
                                    <Button color="danger" onClick={() => handleLogout()}>
                                        Confirm
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default SidebarMenu;
